import React from "react";
import "../style/servicespage.css";
import { Typography } from "@mui/material";
import Servicescard from '../components/Servicescard';
import Infokontakt from '../components/Infokontakt';
import Footer from '../components/Footer';

function Ourservices() {
  return (
    <div className="services-our">
      <div className="photo-first-services-page">
  
        <div className="text-for-our-services">
          <Typography variant="h3"
            sx={{
              color:'var(--secondaryColor)',
              fontFamily:'Rubik',
              fontSize:'50px',
              fontWeight:'bold',
              marginLeft:'50px'
              }}
          >Dienstleistungen</Typography>
        </div>
      </div>
      <div className="content-text-for-our-services">
        <div className="first-text-of-content-services">
          <Typography variant="h6"  sx={{  alignItems: "center", fontFamily:'Rubik', color:'var(--textColor)', fontWeight:'normalf' }}><span className="right-line"></span> Dienstleistungen <span className="left-line"></span></Typography>
          
        </div>
        <div className="second-text-of-content-services-body">
          <Typography variant="body2"
          sx={{
            color:'var(--textColor)',
            fontFamily:'var(--fontFamily)'
          }}
          >
            Unsere Leistungen für Sie: Individuell angepasste Reinigungslösungen, erstklassige Servicequalität und zuverlässige Unterstützung für ein sauberes und angenehmes Umfeld.
          </Typography>
        </div>
      </div>
      <Servicescard />
      <div className="clear">
      </div>
     <Infokontakt />
     <Footer />
    </div>
  );
}

export default Ourservices;
